import React from 'react';
import styled from 'styled-components';

import * as icons from './icons/';

interface Props {
  type: string,
  style?: object,
  color?: string,
  cursor?: string,
  display?: string,
  hoverColor?: string,
  className?: string,
  onClick?: () => void,
}

const SvgWrapper = styled.div` 
  & > svg {
    cursor: pointer;
    display: inline;
  }
`;

export const SvgIcon = ({
  style = {},
  className = '',
  cursor = 'pointer',
  display = 'inline',
  color = 'currentColor',
  hoverColor = 'inherit',
  type,
  ...props
}: Props) => {
  // @ts-ignore
  const Icon = icons[type];

  if (!Icon) {
    console.warn("Icon not found!", type);
    return null;
  }

  return (
    <SvgWrapper className="svg-wrapper">
      <Icon
        {...props}
        color={color}
        style={style}
        className={className}
      />
    </SvgWrapper>    
  );
};
